"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sidebarTranslator = void 0;
exports.sidebarTranslator = {
    en: {
        general: "General",
        output: "Output",
        gameplay: "Gameplay",
        mechanics: "Mechanics",
        locations: "Locations",
        characters: "Characters"
    },
    ru: {
        general: "Общее",
        output: "Вывод",
        gameplay: "Геймплей",
        mechanics: "Механики",
        locations: "Локации",
        characters: "Персонажи"
    },
};
